import Image from "./Image";

export default class Media {
  previewImage?: Image;
  mediaContentType?: string;
  alt?: string;

  constructor(response?: any) {
    if (response != null) {
      this.alt = response.alt;
      this.mediaContentType = response.mediaContentType;
      this.previewImage = new Image(response.previewImage);
    }
  }
}
